module.exports = __webpack_public_path__ + "assets/webfonts/fa-brands-400.woff2";